
import { BaseAppService } from '../base/base.app.service';

export class AppService extends BaseAppService {
    private userId: any;
    constructor(public NotifyService: aboTheme.INotifyService, public SweetAlert: any) {
        "ngInject";
        super();
    }

   
}


// WEBPACK FOOTER //
// ./src/app/main/app.service.ts